//Material UI
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircularProgress from "../CircleProgress";

import "./LoginBox.css";

const LoginBox = (props) => {
  return (
    <div className="login-box">
      <div className="login-form">
        <div className="login-heading">Login</div>
        <div className="login-form-group">
          <div className="login-form-group-id">
            <div className="login-label">Email</div>
            <input
              className="login-input"
              type="text"
              placeholder="Email을 입력해주세요."
              value={props.userId}
              disabled={props.disabled}
              onChange={(e) => props.setUserId(e.target.value)}
            />
          </div>
          <div className="login-form-group-password">
            <div className="login-label">PW</div>
            <div className="login-password-wrapper">
              <input
                className="login-input"
                type={props.passwordShown ? "text" : "password"}
                placeholder="비밀번호를 입력해주세요."
                onKeyDown={props.handlePasswordKeyDown}
                onKeyUp={props.checkCapsLock}
                value={props.password}
                disabled={props.disabled}
                onChange={(e) => props.setPassword(e.target.value)}
              />
              <button
                className="login-password-toggle"
                onClick={props.togglePasswordVisibility}
              >
                {props.passwordShown ? (
                  <VisibilityOffIcon />
                ) : (
                  <VisibilityIcon />
                )}
              </button>
            </div>
            <div className="login-capslock-info">
              {props.capsLock ? (
                <>
                  <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                  <div className="login-capslock-text">Caps Lock is On</div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="signup-button-container">
        <div className="signup-button-wrapper">
          <button
            onClick={() => props.handleNavigate('forgotpassword')}
            className="forgot-password-button"
          >
            Forgot Password
          </button>
        </div>
      </div>
      <button
        className={`login-button ${props.loading ? "loading" : ""}`}
        type="button"
        onClick={props.handleLogin}
        disabled={props.disabled || props.loading}
      >
        {!props.loading ? (
          "Login"
        ) : (
          <CircularProgress color="white" thickness={4} size={19} />
        )}
      </button>
    </div>
  );
};

export default LoginBox;
